export { ReactComponent as AudioObject } from './svgs/audio-object.svg';
